import Vue from 'vue';
import VueInputMask from 'v-mask';

Vue.use(VueInputMask);
